import { gql } from '@apollo/client';

export const CORE_EVENT_FIELDS = gql`
    fragment CoreEventFields on Event {
        recordId
        code
        title
        url
        beginsAt
        endsAt
        image
        location {
            purpose
            address
            city
            stateProvince
            country
        }
    }
`;
